module.exports = __webpack_public_path__ + "media/svg/symbols-129cc9ff.svg";